import styled from 'styled-components';

const TableFooterInfo = styled.p`
  font-size: var(--font-body2);
  color: var(--font-on-primary);
`;

export default TableFooterInfo;
